import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

// Nota: startClose / closeRegister / closeSummary foram removidos — eram código
// morto (nunca chamados em CaixasTab). O fecho é feito via CloseCaixaModal →
// /pos/caixa/fechar, que é a fonte de verdade (db.caixa).

export function useCaixas() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [registers, setRegisters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOpen, setShowOpen] = useState(false);
  const [openingAmount, setOpeningAmount] = useState("");
  const [showClose, setShowClose] = useState(null);
  const [showDetail, setShowDetail] = useState(null); // register object for CashSessionDetailsModal
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });

  const fetchRegisters = useCallback(async () => {
    try {
      const res = await authAxiosRef.current.get(`/financiero/cash-registers?month=${month}`);
      setRegisters(res.data);
    } catch {} finally {
      setLoading(false);
    }
  }, [month]);

  useEffect(() => { fetchRegisters(); }, [fetchRegisters]);

  const openRegister = async () => {
    const amount = parseFloat(openingAmount) || 0;
    try {
      await authAxios.post("/financiero/cash-registers/open", { opening_amount: amount });
      toast.success("Caja abierta");
      setShowOpen(false);
      setOpeningAmount("");
      fetchRegisters();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Error abriendo caja");
    }
  };

  const activeReg = registers.find(r => r.status === "open");

  return {
    registers, loading,
    month, setMonth,
    showOpen, setShowOpen,
    openingAmount, setOpeningAmount,
    showClose, setShowClose,
    showDetail, setShowDetail,
    activeReg,
    openRegister, fetchRegisters,
  };
}
